import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { LEFT, RIGHT } from '../../../../constants/misc';
import handleKeyPress from '../../../../common/handleKeyPress';

export default class Column extends Component {
    state = {
        overTransformIcon: null,
    };

    handleActionClick = (action) => {
        const { blockIndex, columnIdx, mergeColumn, moveColumn, splitColumn, removeAllSelectedElements } = this.props;
        if (action !== null) {
            removeAllSelectedElements();
            switch (action) {
                case 'mergeLeft':
                    mergeColumn({ blockIndex, columnIdx, direction: LEFT });
                    return;
                case 'moveLeft':
                    moveColumn({ blockIndex, columnIdx, direction: LEFT });
                    return;
                case 'split':
                    splitColumn({ blockIndex, columnIdx });
                    return;
                case 'moveRight':
                    moveColumn({ blockIndex, columnIdx, direction: RIGHT });
                    return;
                case 'mergeRight':
                    mergeColumn({ blockIndex, columnIdx, direction: RIGHT });
                    break;
                default:
            }
        }
    };

    render() {
        const { canSplitColumn, previousActionValid, nextActionValid } = this.props;
        const { overTransformIcon } = this.state;

        return (
            <>
                <Styled.ColumnGuideWrapper visible={overTransformIcon !== null} />
                <Styled.ColumnControlWrapper
                    onClick={() => this.handleActionClick(overTransformIcon)}
                    onKeyDown={(e) => handleKeyPress(e, () => this.handleActionClick(overTransformIcon))}
                    tabIndex="0"
                >
                    <Styled.ColumnControlBox>
                        {previousActionValid && (
                            <Styled.LeftIconDiv>
                                <Styled.IconSpan
                                    onMouseOver={() => this.setState({ overTransformIcon: 'mergeLeft' })}
                                    onMouseLeave={() => this.setState({ overTransformIcon: null })}
                                    onFocus={() => this.setState({ overTransformIcon: 'mergeLeft' })}
                                    onBlur={() => this.setState({ overTransformIcon: null })}
                                    role="button"
                                    tabIndex="0"
                                    data-tip
                                    data-for="mergeLeft"
                                >
                                    <Styled.MergeLeftIcon className="material-icons">merge_type</Styled.MergeLeftIcon>
                                    <ReactTooltip id="mergeLeft" place="bottom" effect="solid">
                                        <span style={{ fontWeight: 'bold' }}>Merge Left</span>
                                    </ReactTooltip>
                                </Styled.IconSpan>
                                <Styled.IconSpan
                                    onMouseOver={() => this.setState({ overTransformIcon: 'moveLeft' })}
                                    onMouseLeave={() => this.setState({ overTransformIcon: null })}
                                    onFocus={() => this.setState({ overTransformIcon: 'moveLeft' })}
                                    onBlur={() => this.setState({ overTransformIcon: null })}
                                    role="button"
                                    tabIndex="0"
                                    data-tip
                                    data-for="moveLeft"
                                >
                                    <Styled.SwapLeftIcon className="material-icons">arrow_back</Styled.SwapLeftIcon>
                                    <ReactTooltip id="moveLeft" place="bottom" effect="solid">
                                        <span style={{ fontWeight: 'bold' }}>Swap Left</span>
                                    </ReactTooltip>
                                </Styled.IconSpan>
                            </Styled.LeftIconDiv>
                        )}
                        {canSplitColumn && (
                            <Styled.SplitSpan
                                onMouseOver={() => this.setState({ overTransformIcon: 'split' })}
                                onMouseLeave={() => this.setState({ overTransformIcon: null })}
                                onFocus={() => this.setState({ overTransformIcon: 'split' })}
                                onBlur={() => this.setState({ overTransformIcon: null })}
                                role="button"
                                tabIndex="0"
                                data-tip
                                data-for="split"
                            >
                                <Styled.SplitIcon className="material-icons">call_split</Styled.SplitIcon>
                                <ReactTooltip id="split" place="bottom" effect="solid">
                                    <span style={{ fontWeight: 'bold' }}>Split</span>
                                </ReactTooltip>
                            </Styled.SplitSpan>
                        )}

                        {nextActionValid && (
                            <Styled.RightIconDiv>
                                <Styled.IconSpan
                                    onMouseOver={() => this.setState({ overTransformIcon: 'moveRight' })}
                                    onMouseLeave={() => this.setState({ overTransformIcon: null })}
                                    onFocus={() => this.setState({ overTransformIcon: 'moveRight' })}
                                    onBlur={() => this.setState({ overTransformIcon: null })}
                                    role="button"
                                    tabIndex="0"
                                    data-tip
                                    data-for="moveRight"
                                >
                                    <Styled.Icon className="material-icons">arrow_forward</Styled.Icon>
                                    <ReactTooltip id="moveRight" place="bottom" effect="solid">
                                        <span style={{ fontWeight: 'bold' }}>Swap Right</span>
                                    </ReactTooltip>
                                </Styled.IconSpan>
                                <Styled.IconSpan
                                    onMouseOver={() => this.setState({ overTransformIcon: 'mergeRight' })}
                                    onMouseLeave={() => this.setState({ overTransformIcon: null })}
                                    onFocus={() => this.setState({ overTransformIcon: 'mergeRight' })}
                                    onBlur={() => this.setState({ overTransformIcon: null })}
                                    role="button"
                                    tabIndex="0"
                                    data-tip
                                    data-for="mergeRight"
                                >
                                    <Styled.MergeRightIcon className="material-icons">merge_type</Styled.MergeRightIcon>
                                    <ReactTooltip id="mergeRight" place="bottom" effect="solid">
                                        <span style={{ fontWeight: 'bold' }}>Merge Right</span>
                                    </ReactTooltip>
                                </Styled.IconSpan>
                            </Styled.RightIconDiv>
                        )}
                    </Styled.ColumnControlBox>
                </Styled.ColumnControlWrapper>
            </>
        );
    }
}

Column.propTypes = {
    blockIndex: PropTypes.string.isRequired,
    columnIdx: PropTypes.string.isRequired,
    mergeColumn: PropTypes.func.isRequired,
    moveColumn: PropTypes.func.isRequired,
    splitColumn: PropTypes.func.isRequired,
    removeAllSelectedElements: PropTypes.func.isRequired,
    canSplitColumn: PropTypes.bool.isRequired,
    previousActionValid: PropTypes.bool.isRequired,
    nextActionValid: PropTypes.bool.isRequired,
};
